


































































































































import { mapActions, mapState, mapGetters } from 'vuex';
import SuperAdminTokenManagementWallet from '@/views/SuperAdminViews/super-admin-token-management/SuperAdminTokenManagementWallet.vue';
import SuperAdminTokenManagementWalletDialog from '@/views/SuperAdminViews/super-admin-token-management/SuperAdminTokenManagementWalletDialog.vue';
import SuperAdminTokenManagementTradingSettings from '@/views/SuperAdminViews/super-admin-token-management/SuperAdminTokenManagementTradingSettings.vue';
import SuperAdminTokenManagementBuybackSettings from '@/views/SuperAdminViews/super-admin-token-management/SuperAdminTokenManagementBuybackSettings.vue';
import SuperAdminTokenManagementLiquiditySettings from '@/views/SuperAdminViews/super-admin-token-management/SuperAdminTokenManagementLiquiditySettings.vue';
import { errorToastMessage } from '@/helpers/errorToastMessage';
import {
  createWallet,
  deleteWallet,
  editWallet
} from '@/api/BlockchainWallet';

import type { BlockchainWalletState } from '@/store/modules/blockchain-wallet/BlockchainWalletState';
import type {
  BlockchainWalletItem,
  BlockchainWalletData
} from '@/api/schema';

import type { AxiosError } from 'axios';

export default {
  name: 'SuperAdminTokenManagement',
  data: (): any => ({
    panels: [],
    showDialog: false,
    showDialogBuybackSettings: false,
    showDialogTradingSettings: false,
    showDialogLiquiditySettings: false,
    action: 'create',
    activeWallet: null as BlockchainWalletItem | null,
    type: ''
  }),
  components: {
    SuperAdminTokenManagementWallet,
    SuperAdminTokenManagementWalletDialog,
    SuperAdminTokenManagementTradingSettings,
    SuperAdminTokenManagementBuybackSettings,
    SuperAdminTokenManagementLiquiditySettings
  },
  computed: {
    ...mapState('BlockchainWallet', {
      wallets: (state: BlockchainWalletState) => state.wallets,
      loading: (state: BlockchainWalletState) => state.loading.wallets
    }),
    ...mapGetters('Onboarding', ['operatorId']),
    trading(): BlockchainWalletItem[] {
      return this.wallets.filter((val) => val.type === 'TRADING');
    },
    buyback(): BlockchainWalletItem[] {
      return this.wallets.filter((val) => val.type === 'BUYBACK');
    },
    liquidity(): BlockchainWalletItem[] {
      return this.wallets.filter((val) => val.type === 'LIQUIDITY');
    },
    disabled(): boolean {
      return !this.$role.can.update('token_manage') || this.loading;
    }
  },
  watch: {
    operatorId: {
      handler(newId: number | null): void {
        if (newId) {
          this.getWallet();
          this.panels = [];
        }
      },
      immediate: true
    },
    loading(status: boolean): void {
      if (!status) {
        const panels = [this.trading, this.buyback, this.liquidity];
        this.panels = panels.reduce((acc, wallets, index) => {
          if (wallets.length) {
            acc.push(index);
          }
          return acc;
        }, []);
      }
    }
  },
  methods: {
    ...mapActions('BlockchainWallet', ['getWallet', 'activateWallet']),
    changeStatus(id: number, status: boolean): void {
      this.activateWallet({
        id,
        active: !status
      });
    },
    async handlerDeleteWallet(id: number): Promise<void> {
      await deleteWallet(id)
        .then(() => {
          this.getWallet();
          this.$toast.success('Wallet has been delete');
        })
        .catch((e) => {
          this.$toast.success(e);
        });
    },
    handlerEditWallet(id: number, type: string): void {
      this.type = type;
      this.action = 'edit';
      this.activeWallet = this.wallets.find((val) => val.id === id);
      this.showDialog = true;
    },
    handlerCloseDialog(): void {
      this.showDialog = false;
      this.activeWallet = null;
    },
    editWallets: function (data: BlockchainWalletData): void {
      const handler = this.action === 'edit' ? editWallet : createWallet;

      (handler(data) as Promise<any>)
        .then(() => {
          this.$toast.success(`Wallet has been ${this.action}`);
        })
        .catch((e: AxiosError) => errorToastMessage(e))
        .finally(() => {
          this.showDialog = false;
          this.activeWallet = null;
          this.getWallet();
        });
    },
    handlerCreateWallet(type: string): void {
      this.type = type;
      this.action = 'create';
      this.showDialog = true;
    },
    handlerOpenTradingSettingsDialog(): void {
      this.showDialogTradingSettings = true;
    },
    closeDialogTradingSettingsDialog(): void {
      this.showDialogTradingSettings = false;
    },
    handlerOpenBuybackSettingsDialog(): void {
      this.showDialogBuybackSettings = true;
    },
    closeDialogBuybackSettingsDialog(): void {
      this.showDialogBuybackSettings = false;
    },
    handlerOpenLiquiditySettingsDialog(): void {
      this.showDialogLiquiditySettings = true;
    },
    closeDialogLiquiditySettingsDialog(): void {
      this.showDialogLiquiditySettings = false;
    }
  }
};
